import { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Calendar } from "primereact/calendar";
import { Skeleton } from "primereact/skeleton";
import { Link } from "react-router-dom";
import { getAllDetails, getDetailsFromId } from "../../service/ProductService";
import { GET_DASHBOARD_DATA } from "../../config/ApiConstant";
import { Chart } from "primereact/chart";
import { Toast } from "primereact/toast";
import { formatYear } from "../../appconfig/AppHelper";

const Dashboard = () => {
  document.title = "Dashboard | Agriown";

  // Set Toast
  const toast = useRef<Toast>(null);

  //Loading/Page Loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  const [dashboardData, setDashboardData] = useState<any>({});
  const [bookingData, setbookingData] = useState<any>({});

  //chartData
  const [totalOrderData, setTotalOrderData] = useState({});
  const [totalOrderOptions, setTotalOrderOptions] = useState({});

  // Date Object
  let today = new Date();
  const [orderYear, setOrderYear] = useState<any>(new Date(today));

  // get dashboard data
  useEffect(() => {
    getDashboard();
  }, []);

  useEffect(() => {
    getDashboardChartData();
  }, [orderYear]);

  // get chart data
  useEffect(() => {
    getOrderData();
  }, [bookingData]);

  // set chart data
  const getOrderData = () => {
    let labelsVal: any = "";
    let graphVal: any = "";
    let maxVal: any = "";

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    if (!window.cn(bookingData) && bookingData) {
      labelsVal = monthNames.length > 0 && monthNames.map((item: any) => item);
      graphVal =
        bookingData.length > 0 && bookingData.map((item: any) => item?.count);

      if (!window.cn(graphVal) && graphVal.length > 0) {
        maxVal = Math.max(...graphVal);
      }
    }

    const data = {
      labels: labelsVal,
      datasets: [
        {
          label: "Bookings",
          data: graphVal,
          borderColor: "#438440",
          pointBackgroundColor: "#438440",
          backgroundColor: "rgba(0, 208, 222, 0.05)",
          fill: true,
          tension: 0.4,
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 1,
      plugins: {
        legend: {
          display: false,
        },
      },
      responsive: true,
      hover: {
        mode: "index",
      },
      scales: {
        y: {
          min: 0,
          max: !window.cn(maxVal) && maxVal <= 20 ? 20 + 2 : maxVal + 5,
          ticks: {
            stepSize: !window.cn(maxVal) && maxVal < 30 ? 2 : 5,
          },
        },
      },
    };

    setTotalOrderData(data);
    setTotalOrderOptions(options);
  };

  const getDashboardChartData = async () => {
    try {
      setPageLoad(true);
      const response = await getDetailsFromId(
        GET_DASHBOARD_DATA,
        "year",
        formatYear(orderYear)
      );

      if (response) {
        setbookingData(response?.yearly_data);
      }
    } catch (error) {
      setPageLoad(false);
      setbookingData([]);
    } finally {
      setPageLoad(false);
    }
  };

  // Get dashboard data from API
  const getDashboard = async () => {
    setPageLoad(true);
    try {
      const response = await getAllDetails(GET_DASHBOARD_DATA);

      if (response) {
        setDashboardData(response);
        setPageLoad(false);
      } else {
        setDashboardData([]);
        setPageLoad(true);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu={"Dashboard"}
        pageName={"Statistics"}
        pageTitle={"Dashboard"}
      />
      <div className="layout-dashboard">
        <div className="grid mt-2">
          <div className="col-12 md:col-6 lg:col-3">
            <Link to={"/booking"}>
              <div className="card dashbaord-main-box">
                <div className="inner flex flex-column justify-content-between">
                  <h2 className="mb-0 title-text ">Total Bookings</h2>
                  <div className="flex align-items-center justify-content-between">
                    <h3 className="mt-0 mb-0 num-text">
                      {!pageLoad ? (
                        !window.cn(dashboardData) &&
                        !window.cn(dashboardData?.total_bookings) ? (
                          `${dashboardData?.total_bookings}`
                        ) : (
                          ""
                        )
                      ) : (
                        <Skeleton
                          width="5rem"
                          height="2.5rem"
                          className="rounded"
                        />
                      )}
                    </h3>
                    <img
                      src="https://res.cloudinary.com/dpc2muwar/image/upload/v1759300150/farm-tech_m51mfi.gif"
                      width="40"
                      height="40"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-12 md:col-6 lg:col-3">
            <Link to={"/booking"} state={{ today: true }}>
              <div className="card dashbaord-main-box">
                <div className="inner flex flex-column justify-content-between">
                  <h2 className="mb-0 title-text">Today's Booking</h2>
                  <div className="flex align-items-center justify-content-between">
                    <h3 className="mt-0 mb-0 num-text">
                      {!pageLoad ? (
                        !window.cn(dashboardData) &&
                        !window.cn(dashboardData?.today_bookings) ? (
                          dashboardData?.today_bookings
                        ) : (
                          ""
                        )
                      ) : (
                        <Skeleton
                          width="5rem"
                          height="2.5rem"
                          className="rounded"
                        />
                      )}
                    </h3>
                    <img
                      src="https://res.cloudinary.com/dpc2muwar/image/upload/v1759300150/farm-tech_m51mfi.gif"
                      width="40"
                      height="40"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-12 md:col-6 lg:col-3">
            <Link to={"/farmer"}>
              <div className="card dashbaord-main-box">
                <div className="inner flex flex-column justify-content-between">
                  <h2 className="mb-0 title-text">Total Farmers</h2>
                  <div className="flex align-items-center justify-content-between">
                    <h3 className="mt-0 mb-0 num-text">
                      {!pageLoad ? (
                        !window.cn(dashboardData) &&
                        !window.cn(dashboardData?.total_farmer) ? (
                          dashboardData?.total_farmer
                        ) : (
                          ""
                        )
                      ) : (
                        <Skeleton
                          width="5rem"
                          height="2.5rem"
                          className="rounded"
                        />
                      )}
                    </h3>
                    <img
                      src="https://res.cloudinary.com/dpc2muwar/image/upload/v1759300150/farmer_nzylbn.gif"
                      width="40"
                      height="40"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-12 md:col-6 lg:col-3">
            <Link to={"/operator/operator-list"}>
              <div className="card dashbaord-main-box">
                <div className="inner flex flex-column justify-content-between">
                  <h2 className="mb-0 title-text">Total Operators</h2>
                  <div className="flex align-items-center justify-content-between">
                    <h3 className="mt-0 mb-0 num-text">
                      {!pageLoad ? (
                        !window.cn(dashboardData) &&
                        !window.cn(dashboardData?.total_operator) ? (
                          dashboardData?.total_operator
                        ) : (
                          ""
                        )
                      ) : (
                        <Skeleton
                          width="5rem"
                          height="2.5rem"
                          className="rounded"
                        />
                      )}
                    </h3>
                    <img
                      src="https://res.cloudinary.com/dpc2muwar/image/upload/v1759300153/operator_hsy4qz.gif"
                      width="40"
                      height="40"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Chart Start */}
        <div className="grid">
          <div className="col-12 md:col-12">
            <div className="card widget-revenue-graph">
              <>
                <div className="card-header mb-2">
                  <h3 className="overview-text-h" style={{ fontSize: "18px" }}>
                    Bookings
                  </h3>
                  {!window.cn(bookingData) && (
                    <Calendar
                      value={orderYear}
                      onChange={(e) => setOrderYear(e.value)}
                      view="year"
                      dateFormat="yy"
                      showIcon
                    />
                  )}
                </div>
                {!pageLoad ? (
                  !window.cn(bookingData) ? (
                    <div className="graph">
                      <Chart
                        type="line"
                        id="revenue-chart"
                        data={totalOrderData}
                        options={totalOrderOptions}
                      ></Chart>
                    </div>
                  ) : (
                    <p className="text-center py-2">No Bookings Found</p>
                  )
                ) : (
                  <Skeleton width="100" height="20rem" className="rounded" />
                )}
              </>
            </div>
          </div>
        </div>

        {/* Chart End */}
      </div>
    </>
  );
};

export default Dashboard;
